import React, { useRef, useState } from 'react';
import contiChapter from '../images/conti.png';

import './ChapterPreview.css';

const ChapterPreview = ({
  chapter,
  onClose
}) => {
  const previewRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  if (!chapter) {
    return null;
  }

  const handleScroll = () => {
    if (!previewRef.current) return;

    // Titlul apare dupa ce utilizatorul incepe efectiv sa dea scroll
    setIsScrolled(previewRef.current.scrollTop > 25);
  };

  return (
    <div
      className="chapter-preview-inline"
      ref={previewRef}
      onScroll={handleScroll}
    >

      <div
        className={`chapter-preview-topbar ${
          isScrolled ? 'chapter-preview-topbar-scrolled' : ''
        }`}
      >

        <button
          className="chapter-preview-popup-close"
          onClick={onClose}
          aria-label="Inchide"
          type="button"
        >
          <span className="chapter-preview-back-text">
            Inapoi
          </span>

          <span
            className="chapter-preview-close-x"
            aria-hidden="true"
          >
            ×
          </span>
        </button>

        <div className="chapter-preview-mobile-title">
          {chapter.title}
        </div>

        <div className="line-prevew-chapter" />

      </div>

      <div className="chapter-preview-popup-header">

        <div className="chapter-preview-popup-icon">
          <img
            src={contiChapter}
            alt="Conti"
            className="chapter-preview-popup-conti"
          />
        </div>

        <div className="chapter-preview-popup-header-text">

        

          <h2>
            {chapter.title}
          </h2>

          {chapter.preview?.description && (
            <p>
              {chapter.preview.description}
            </p>
          )}

        </div>
      </div>

      <div className="chapter-preview-popup-divider" />

      <h3 className="chapter-preview-popup-heading">
        {chapter.preview?.heading || 'Ce vei invata'}
      </h3>

      <div className="chapter-preview-popup-objectives">

        {chapter.preview?.objectives?.map(
          (objective, index) => (
            <div
              className="chapter-preview-popup-objective"
              key={index}
            >
              <div className="chapter-preview-popup-check">
                ✓
              </div>

              <p>
                {objective}
              </p>
            </div>
          )
        )}

      </div>

    </div>
  );
};

export default ChapterPreview;